import React from 'react'
import styled from 'styled-components'
import { TextCP } from 'submodules/nerit-framework-ui/common/components/text/TextCP'
import {
    LOGIN_ALERT_COLOR,
    LOGIN_ALERT_FONT_SIZE,
    LOGIN_VIEW_SECTION_ORDER,
    LoginSubmitAlertTP,
    loginAlertMessages,
} from 'app/components/form-login/inner/loginFormFeedback'

interface ICPProps {
    capsLock: boolean
    submitAlert?: LoginSubmitAlertTP
}

/**
 * Avisos vermelhos da tela de login, abaixo do título e acima dos campos.
 */
export function FormLoginAlertsICP(props: ICPProps): JSX.Element {
    const messages = loginAlertMessages({
        capsLock: props.capsLock,
        submitAlert: props.submitAlert,
    })

    if (!messages.length)
        return <></>

    return (
        <WrapperSCP data-login-alert-region={'true'} data-login-section={LOGIN_VIEW_SECTION_ORDER[1]}>
            {
                messages.map((message) => (
                    <TextCP
                        key={message}
                        text={message}
                        color={LOGIN_ALERT_COLOR}
                        size={LOGIN_ALERT_FONT_SIZE}
                    />
                ))
            }
        </WrapperSCP>
    )
}

const WrapperSCP = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`
